import { reactive, computed } from 'vue'

const state = reactive({
  user: null,
  isAuthenticated: false,
  cartCount: 0
})

// Initialize from window.authUser if available
if (typeof window !== 'undefined' && window.authUser) {
  state.user = window.authUser
  state.isAuthenticated = !!window.authUser
}

export const useAuthStore = () => {
  const setUser = (userData) => {
    state.user = userData
    state.isAuthenticated = !!userData
    
    // Also update window.authUser for consistency
    if (typeof window !== 'undefined') {
      window.authUser = userData
    }
  }

  const setCartCount = (count) => {
    state.cartCount = count
  }

  const clearAuth = () => {
    state.user = null
    state.isAuthenticated = false
    if (typeof window !== 'undefined') {
      window.authUser = null
    }
  }

  const updateCartCount = (count) => {
    state.cartCount = count
  }

  const initAuth = (initialData) => {
    if (initialData?.user) {
      setUser(initialData.user)
    }
    if (initialData?.cartCount !== undefined) {
      setCartCount(initialData.cartCount)
    }
  }

  return {
    // State
    user: computed(() => state.user),
    isAuthenticated: computed(() => state.isAuthenticated),
    cartCount: computed(() => state.cartCount),
    
    // Actions
    setUser,
    setCartCount,
    clearAuth,
    updateCartCount,
    initAuth
  }
}

// Global helper for updating cart badge from anywhere
export const updateGlobalCartBadge = (count) => {
  state.cartCount = count
}

// Listen for auth-updated events from checkout or other sources
if (typeof window !== 'undefined') {
  window.updateCartBadge = updateGlobalCartBadge
  
  // Listen for auth state changes
  window.addEventListener('auth-updated', (event) => {
    if (event.detail?.user) {
      state.user = event.detail.user
      state.isAuthenticated = true
      window.authUser = event.detail.user
    }
  })
  
  // Listen for logout events
  window.addEventListener('auth-logout', () => {
    state.user = null
    state.isAuthenticated = false
    window.authUser = null
  })
}
